"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeatSimulationVersion = void 0;
/**
 * @description An enum to determine whether the user has chosen MEAT simulation or analysis.
 */
var MeatSimulationVersion;
(function (MeatSimulationVersion) {
    MeatSimulationVersion["NOT_SELECTED"] = "NOT_SELECTED";
    MeatSimulationVersion["SIMULATION"] = "SIMULATION";
    MeatSimulationVersion["ANALYSIS"] = "ANALYSIS";
})(MeatSimulationVersion = exports.MeatSimulationVersion || (exports.MeatSimulationVersion = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVhdC1zaW11bGF0aW9uLXZlcnNpb24uZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tZWF0LWFuYWx5c2lzL3R5cGVzL21lYXQtc2ltdWxhdGlvbi12ZXJzaW9uLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUg7O0dBRUc7QUFDSCxJQUFZLHFCQUlYO0FBSkQsV0FBWSxxQkFBcUI7SUFDL0Isc0RBQTZCLENBQUE7SUFDN0Isa0RBQXlCLENBQUE7SUFDekIsOENBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUpXLHFCQUFxQixHQUFyQiw2QkFBcUIsS0FBckIsNkJBQXFCLFFBSWhDIn0=